module.exports = __webpack_public_path__ + "img/clients-04.9adf2aac.svg";